export * from './footer.component'